import type { ReactNode } from 'react';
import { errorMessage } from '../lib/api';
import styles from './StateViews.module.css';

export function LoadingBlock({ label, height = 120 }: { label: string; height?: number }) {
  return (
    <div className={styles.loading} role="status" aria-live="polite" style={{ minHeight: height }}>
      <span className={styles.pulse} aria-hidden="true" />
      {label}
    </div>
  );
}

export function EmptyState({ title, body, children }: { title: string; body: string; children?: ReactNode }) {
  return (
    <div className={styles.empty}>
      <strong className={styles.title}>{title}</strong>
      <p className={styles.body}>{body}</p>
      {children}
    </div>
  );
}

export interface ErrorPanelProps {
  error: unknown;
  onRetry: () => void;
  title?: string;
  body?: string;
  children?: ReactNode;
}

export function ErrorPanel({ error, onRetry, title = 'COULDN’T LOAD THIS', body, children }: ErrorPanelProps) {
  return (
    <div className={styles.error} role="alert">
      <strong className={styles.title}>{title}</strong>
      <p className={styles.body}>{body ?? errorMessage(error)}</p>
      <button type="button" className="btn btn-outline" onClick={onRetry}>TRY AGAIN ↻</button>
      {children}
    </div>
  );
}
